import { render } from "./_simple-group.vue?vue&type=template&id=6de7e871"
import script from "./_simple-group.vue?vue&type=script&lang=js"
export * from "./_simple-group.vue?vue&type=script&lang=js"

import "./_simple-group.vue?vue&type=style&index=0&id=6de7e871&lang=less&scope=true"

import exportComponent from "D:\\微客\\we_customer_guide\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__